import React, { useState, useEffect } from "react";

export default function CodeChallenge() {
  
const questions = [
  {
    code: String.raw`s = "hello"
print(len(s))`,
    question: "What does the code output?",
    options: { A: "4", B: "5", C: "6", D: "Error" },
    answer: "B",
    explanation: "'hello' contains 5 characters."
  },

  {
    code: String.raw`arr = [3,1,2]
arr.sort()
print(arr)`,
    question: "What will be printed?",
    options: { A: "[3,1,2]", B: "[1,2,3]", C: "[2,1,3]", D: "Error" },
    answer: "B",
    explanation: "sort() arranges the list in ascending order."
  },

  {
    code: String.raw`s = "abcabc"
print(s.count("a"))`,
    question: "How many times does 'a' appear?",
    options: { A: "1", B: "2", C: "3", D: "4" },
    answer: "B",
    explanation: "'a' appears twice in 'abcabc'."
  },

  {
    code: String.raw`arr = [1,2,3,4]
for x in arr:
    print(x*2)`,
    question: "How many total prints occur?",
    options: { A: "2", B: "3", C: "4", D: "8" },
    answer: "C",
    explanation: "The loop runs once for each element: 4 elements → 4 prints."
  },

  {
    code: String.raw`s = "racecar"
print(s == s[::-1])`,
    question: "What does this check?",
    options: { A: "If string is uppercase", B: "If string is empty", C: "If string is palindrome", D: "If string is numeric" },
    answer: "C",
    explanation: "Reversing the string and comparing checks for palindrome."
  },

  {
    code: String.raw`arr = [5,2,8,1]
print(max(arr))`,
    question: "What is the time complexity of max() on a list of n items?",
    options: { A: "O(1)", B: "O(log n)", C: "O(n)", D: "O(n²)" },
    answer: "C",
    explanation: "max() scans the entire list → linear time."
  },

  {
    code: String.raw`s = "Hello World"
print(s.lower())`,
    question: "What does .lower() do?",
    options: { A: "Capitalizes every word", B: "Converts to lowercase", C: "Reverses the string", D: "Removes whitespace" },
    answer: "B",
    explanation: "lower() converts all characters to lowercase."
  },

  {
    code: String.raw`arr = []
arr.append(10)
arr.append(20)
print(len(arr))`,
    question: "What is printed?",
    options: { A: "0", B: "1", C: "2", D: "3" },
    answer: "C",
    explanation: "Two values were appended → length is 2."
  },

  {
    code: String.raw`s = "python"
for i in range(len(s)):
    print(s[i])`,
    question: "What is the time complexity?",
    options: { A: "O(1)", B: "O(n)", C: "O(n²)", D: "O(log n)" },
    answer: "B",
    explanation: "Loop runs once per character → linear time."
  },

  {
    code: String.raw`arr = [1,2,3,4,5]
target = 3
print(target in arr)`,
    question: "What does the 'in' keyword perform here?",
    options: { A: "Binary search", B: "Constant-time lookup", C: "Linear search", D: "Hash lookup" },
    answer: "C",
    explanation: "'in' on a list searches linearly through elements."
  }
];



  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [typing, setTyping] = useState("");

  // Typewriter effect
  useEffect(() => {
    const text = questions[current].code;
    let i = 0;
    setTyping("");

    const interval = setInterval(() => {
      // setTyping(prev => prev + text.charAt(i));
      i++;
      setTyping(text.slice(0, i));
      if (i >= text.length) clearInterval(interval);
    }, 30);

    return () => clearInterval(interval);
  }, [current]);

  const checkAnswer = (choice) => {
    const q = questions[current];

    if (choice === q.answer) {
      setScore(score + 1);
      setFeedback(`✅ Correct! ${q.explanation}`);
    } else {
      setFeedback(`❌ Oops! Correct answer: ${q.answer}) ${q.options[q.answer]}. ${q.explanation}`);
    }
  };

  const nextQuestion = () => {
    if (current + 1 < questions.length) {
      setCurrent(current + 1);
      setFeedback("");
    }
  };

  const restartGame = () => {
    setCurrent(0);
    setScore(0);
    setFeedback("");
  };

  const endScreen = current >= questions.length;

  // INLINE STYLES
  const styles = {
    body: {
      margin: 0,
      background: "radial-gradient(circle at center, #11be28ff, #000000ff 80%)",
      height: "100%",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      fontFamily: "Courier New, monospace",
    },
    container: {
      textAlign: "center",
      width: "90%",
      maxWidth: "800px",
    },
    codeBox: {
      background: "#111",
      border: "2px solid #0ff",
      borderRadius: "12px",
      padding: "20px",
      textAlign: "left",
      color: "#00ffcc",
      whiteSpace: "pre-wrap",
      minHeight: "120px",
      boxShadow: "0 0 20px #0ff",
      marginBottom: "20px",
      whiteSpace: "pre-wrap",
      overflow: "visible",
      lineHeight: "1.4",
      letterSpacing: "0.5px",
      textShadow: "none"

    },
    button: {
      padding: "15px",
      borderRadius: "15px",
      border: "2px solid #fff",
      fontSize: "1.2em",
      cursor: "pointer",
      background: "none",
      transition: "0.3s",
      width: "100%",
      marginTop: "10px",
    },
    nextBtn: {
      marginTop: "20px",
      padding: "15px 30px",
      fontSize: "1.2em",
      backgroundColor: "#00e6ff",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
    },
  };

  if (endScreen) {
    return (
      <div style={styles.body}>
        <h1>You scored {score} / {questions.length}</h1>
        <button style={styles.nextBtn} onClick={restartGame}>Play Again 🔁</button>
      </div>
    );
  }

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h3  style={{ color:"orange"  }}  >⚡ Code & Choose Challenge</h3>

        <pre style={styles.codeBox}><code>{typing}</code></pre>


        <h3 style={{ color: "cyan" }}>{questions[current].question}</h3>

        <button style={{...styles.button, borderColor:"#00bfff", color:"#00bfff"}} onClick={() => checkAnswer("A")}>
          A) {questions[current].options.A}
        </button>

        <button style={{...styles.button, borderColor:"#ff69b4", color:"#ff69b4"}} onClick={() => checkAnswer("B")}>
          B) {questions[current].options.B}
        </button>

        <button style={{...styles.button, borderColor:"#00ff7f", color:"#00ff7f"}} onClick={() => checkAnswer("C")}>
          C) {questions[current].options.C}
        </button>

        <button style={{...styles.button, borderColor:"#ffff66", color:"#ffff66"}} onClick={() => checkAnswer("D")}>
          D) {questions[current].options.D}
        </button>

        <div style={{ marginTop:"20px", minHeight:"40px" }}>{feedback}</div>

        <div><button style={styles.nextBtn} onClick={nextQuestion}>Next ➡️</button></div>
      </div>
    </div>
  );
}
